export default __webpack_public_path__ + "static/media/Strifescar Helm.acce9ae0.jpg";